<template>
  <Popup
    @click-overlay="$emit('panel', type)"
    :position="position"
    v-model="panelShow"
    class="popup-style"
    :style="{
      width: width,
      height: height,
      borderTopLeftRadius: radius,
      borderTopRightRadius: radius,
    }"
  >
    <div v-if="title">
      <NavBar v-if="title" :title="title">
        <span
          :style="{ color: leftColor }"
          v-if="left"
          @click="$emit('panel', type)"
          slot="left"
          >{{ left }}</span
        >
        <span
          :style="{ color: rightColor }"
          v-if="right"
          @click="$emit('panel', type, true)"
          slot="right"
          >{{ right }}</span
        >
        <Icon
          size="18px"
          v-else
          @click="$emit('panel', type)"
          slot="right"
          name="cross"
        />
      </NavBar>
    </div>

    <slot></slot>
  </Popup>
</template>

<script>
import { Icon, NavBar, Popup } from "vant";

export default {
  props: {
    title: { type: String },
    position: { type: String, default: "bottom" },
    type: { type: String, required: true },
    width: { type: String, default: "100%" },
    height: { type: String, default: "100%" },
    radius: { type: String, default: "0" },
    show: { type: Boolean, default: false },
    left: { type: String },
    right: { type: String },
    leftColor: { type: String, default: "red" },
    rightColor: { type: String, default: "#228EFA" },
  },
  components: {
    Popup,
    Icon,
    NavBar,
  },
  computed: {
    panelShow: {
      set(v) {
        return v;
      },
      get() {
        return this.show;
      },
    },
  },
};
</script>

<style lang="less" scoped>
.popup-style {
  overflow: hidden;
}
</style>
